module.exports = __webpack_public_path__ + "static/img/20016 (6).c5ffee0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20016 (6).webp
// module id = sGrU
// module chunks = 14